import { render } from "./InfobarMenu.vue?vue&type=template&id=b92eea46&scoped=true"
import script from "./InfobarMenu.vue?vue&type=script&lang=js"
export * from "./InfobarMenu.vue?vue&type=script&lang=js"

import "./InfobarMenu.vue?vue&type=style&index=0&id=b92eea46&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b92eea46"]])

export default __exports__